import { validFlowKey } from 'pages/postOnboard/PostOnboardContainer/PostOnboardContainer';
import { checkMarketSuppliedForVendors } from '../../api/vendorMarketplaceApi';

const determineFlow = ({
  hasVenue,
  city,
  state,
}: {
  hasVenue: boolean;
  city?: string;
  state?: string;
}): Promise<validFlowKey> => {
  // User in supplied market or unsure of location (no city/state), and no venue... A1.
  // User not in a supplied market... Flow B1
  // User in supplied market, and has venue... A2.

  if (city && state) {
    return checkMarketSuppliedForVendors({
      city,
      state,
    })
      .then(
        (response): validFlowKey => {
          const { venueMarket, photographerMarket } = response;
          if (venueMarket && !hasVenue) return 'A1';
          if (photographerMarket) return 'A2';
          // Unsupplied market for venue or photographer
          return 'B1';
        }
      )
      .catch(
        (): validFlowKey => {
          // We received an error, but since we are unsure about the "supplied" status
          // let's allow the couple to move forward as if not in a supplied market
          return 'B1';
        }
      );
  }
  // User is unsure of location (no city/state)
  if (!hasVenue) {
    return Promise.resolve('A1');
  }
  return Promise.resolve('B1');
};

export default determineFlow;
